// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"ReviewStats_ratingContainer__9Fj0l","detailsContainer":"ReviewStats_detailsContainer__eVQmm"};